import React from 'react';
export function ProofBar() {
  return <div className="bg-gradient-to-br from-card-bg to-[rgba(107,0,182,0.3)] border-y border-[rgba(194,0,111,0.3)] py-3 md:py-4 px-5" data-id="element-245" data-mp="1r30i1c2q3qdy">
      <div className="max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-5 text-center" data-id="element-246" data-mp="7l2cnj87ld8p">
        <div className="flex flex-col items-center" data-id="element-247" data-mp="cjvtnlmpfmdm">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-248" data-mp="cikl78ibdqg6">
            40%
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-249" data-mp="3j7a6bejkttc">
            Riduzione dell'ansia, secondo i protocolli delle neuroscienze
            cognitive
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-250" data-mp="3pqp5x2ef59vl">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-251" data-mp="3prgqli6h9n73">
            4 Vol.
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-252" data-mp="1nzc4inbntk4a">
            Collezione completa in formato digitale PDF — Il Cammino verso la
            Guarigione
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-253" data-mp="2sclygw4fytcu">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-254" data-mp="2nf2h3ncg60go">
            21 giorni
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-255" data-mp="2x5ourc0lsgwq">
            Pratiche quotidiane di pochi minuti per riprogrammare il ciclo
          </p>
        </div>
      </div>
    </div>;
}